<div [formGroup]="form" class="flex justify-between items-center py-2 w-full gap-4">
  <div class="flex justify-between items-center w-10/12 gap-4">

    <mat-form-field class="input-tg w-full" appearance="outline">
      <mat-label>Tipo Documento</mat-label>
      <mat-select formControlName="docType">
        @for (type of listType; track type.id) {
        <mat-option [value]="type">{{ type.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="input-tg w-full" appearance="outline">
      <mat-label>Descrição</mat-label>
      <input matInput formControlName="description" placeholder="Ex: Contrato Social" />
    </mat-form-field>

    <div class="flex w-full relative">
      <input hidden type="file" (change)="onFileSelected($event)" #fileInput [accept]="getAllowedTypes()" />
      <mat-form-field class="input-tg input-btn-icon w-full" appearance="outline">
        <mat-label>Arquivo</mat-label>
        <input matInput formControlName="file" [value]="fileName" readonly />

        @if (!isEditing) {
        <button mat-icon-button matSuffix (click)="fileInput.click()" type="button">
          <mat-icon>upload</mat-icon>
        </button>
        } @else {
        <mat-icon matSuffix class="text-gray-400">lock</mat-icon>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="flex items-center justify-end mb-5 gap-2">
    @if (isEditing) {
    <button mat-stroked-button color="warn" (click)="resetForm()" type="button">
      Cancelar
    </button>
    }

    <button mat-flat-button class="btn-tg" (click)="submit()" [disabled]="form.invalid || loading" color="primary">
      @if (loading) {
      Carregando...
      } @else {
      {{ isEditing ? 'Atualizar' : 'Adicionar' }}
      }
    </button>
  </div>
</div>